module.exports = __webpack_public_path__ + "static/media/infiltration_movement_example.147b1a8c.jpg";